<template>
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {provide} from 'vue';
    import {NuxtPage} from '#components';
    import {use3rdParties, useHTMLAttrsLang, usePrismicPreviewScript, usePrismicClient} from '#imports';
    import {PRISMIC_CLIENT} from '~/keys';

    usePrismicPreviewScript();
    const client = usePrismicClient();
    provide(PRISMIC_CLIENT, client);

    use3rdParties();
    useHTMLAttrsLang();
</script>
